import { render, staticRenderFns } from "./CopyrightAmendmentTaskQueue.vue?vue&type=template&id=87f4783c&scoped=true&"
import script from "./CopyrightAmendmentTaskQueue.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentTaskQueue.vue?vue&type=style&index=0&id=87f4783c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f4783c",
  null
  
)

export default component.exports